import { localisedValue } from "utils"
const hierarchicalClientTypeTransformer = data => {
  if (!Array.isArray(data)) return []
  return data.map(item => ({
    key: item.id?.toString(),
    label: localisedValue({ object: item, key: "name" }),
    value: item.id?.toString(),
    ...(item.children?.length
      ? { children: hierarchicalClientTypeTransformer(item.children) }
      : {}),
  }))
}

export default hierarchicalClientTypeTransformer
